import * as React from 'react';
import { Button, Typography } from 'omakase';
import { Container } from 'ui';
import { IconArrowRight } from '@tock/icons';
import { IconArrowRight as IconArrowRightLegacy } from 'ui/icons';
import { IconMigrationUtil } from 'omakase/utils/IconMigrationUtil';
import { Theme, css } from '@emotion/react';

const callToActionHeroRoot = ({ spacing, colors }: Theme) => css`
  background-color: ${colors.bgLight};
  padding-bottom: ${spacing(4.5)}px;
  padding-top: ${spacing(6)}px;
  text-align: center;
`;

export interface CallToActionHeroProps {
  buttonText?: string;
  className?: string;
  onClick?(event: React.MouseEvent<HTMLButtonElement>): void;
  subtitle?: string;
  title: string;
}

export const CallToActionHero: React.FunctionComponent<CallToActionHeroProps> = ({
  className,
  onClick,
  buttonText,
  subtitle,
  title,
}) => {
  return (
    <div css={callToActionHeroRoot} className={className}>
      <Container>
        <Typography
          mb={subtitle || buttonText ? 3.5 : 0}
          component="h1"
          variant="decorative"
          data-testid="tocktogo-title"
          align="center"
        >
          {title}
        </Typography>
        {subtitle ? (
          <Typography
            align="center"
            mb={buttonText ? 4 : 0}
            component="h2"
            variant="body02"
            data-testid="tocktogo-subtitle"
          >
            {subtitle}
          </Typography>
        ) : null}
        {buttonText && onClick ? (
          <Button
            data-testid={buttonText}
            iconEnd={
              <IconMigrationUtil
                legacyIcon={<IconArrowRightLegacy />}
                newIcon={<IconArrowRight />}
              />
            }
            variant="primary"
            size="large"
            onClick={onClick}
          >
            {buttonText}
          </Button>
        ) : null}
      </Container>
    </div>
  );
};
